module.exports = __webpack_public_path__ + "img/Pahang.36da2629.png";